import React from "react";
import { useFormikContext } from "formik";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export default function LocationActionButtons({ isEditing, setIsEditing, onClose }) {
  const { handleSubmit, isSubmitting } = useFormikContext();

  return (
    <>
      {isEditing ? (
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleSubmit}
          disabled={isSubmitting}
          startIcon={isSubmitting && <CircularProgress size={16} />}
        >
          Save
        </Button>
      ) : (
        <Button variant="outlined" color="primary" onClick={() => setIsEditing(true)}>
          Edit Location Info
        </Button>
      )}
    </>
  );
}
